<p-toast [key]="toastKey" position="top-right"></p-toast>
<fieldset [ngClass]="classeModeApplication">
	<legend>{{ 'SIGALE_ANGULAR.COMPONENTS.CACHE.TITRE' | translate }}</legend>
	<hr *ngIf="!modeApplicationCohabitation">
	<form class="col mx-auto form-horizontal">
		<div class="form-group text-center">
			<div class="section-choix-cache">
				<div class="label-dropdown">
					<label for="caches" class="col-form-label">{{ 'SIGALE_ANGULAR.COMPONENTS.CACHE.CACHE' | translate }}</label>
					<p-dropdown class="mx-3"
					            id="caches"
					            name="caches"
					            [options]="caches"
					            [(ngModel)]="cache"
					            optionLabel="cacheName"
					            [filter]="true"
					            filterBy="cacheName"
					            [autoOptionFocus]="true"
					>
						<ng-template let-cache pTemplate="item">
							{{ cache.cacheName }}
							<span class="count" *ngIf="cache?.memoryStoreObjectCount != undefined"> {{ ' | ' + cache.memoryStoreObjectCount + ' objet(s)' }}</span>
							<span class="hits" *ngIf="cache?.hits != undefined"> {{ ' | ' + cache.hits + ' hits' }}</span>
							<span class="misses" *ngIf="cache?.misses != undefined"> {{ ' | ' + cache.misses + ' misses' }}</span>
							<span class="puts" *ngIf="cache?.puts != undefined"> {{ ' | ' + cache.puts + ' puts' }}</span>
						</ng-template>
					</p-dropdown>
				</div>

				<div class="actions">
					<button *ngIf="!modeApplicationCohabitation" pButton class="bouton-admin btn" id="clear" (click)="clear(cache)" [label]="'SIGALE_ANGULAR.COMPONENTS.CACHE.BTN_SUPPRIMER' | translate"></button>
					<button *ngIf="!modeApplicationCohabitation" pButton class="bouton-admin btn refresh" (click)="lister()"><i class="pi pi-refresh" [ngClass]="{'pi-spin': loadingIndicator}"></i>
					</button>
					<button *ngIf="modeApplicationCohabitation" type="submit" class="btn btn-medium" id="clear" (click)="clear(cache)">{{ 'SIGALE_ANGULAR.COMPONENTS.CACHE.BTN_SUPPRIMER' | translate }}</button>
					<button *ngIf="modeApplicationCohabitation" class="btn bouton-admin" (click)="lister()"><i class="pi pi-refresh" [ngClass]="{'pi-spin': loadingIndicator}"></i></button>
				</div>
			</div>
		</div>
	</form>
</fieldset>

